import React from 'react';

import {
  imageFile,
  pathForMime,
  IMAGE_SIZES
} from '../../../utils/helpers/imageHelper';

import CorePicture from './CorePicture';

const Picture = (props) => {
  const {
    src,
    alt,
    size = IMAGE_SIZES.ORIGINAL,
    $height,
    className,
    dataTestId
  } = props;

  const useOriginal = size === IMAGE_SIZES.ORIGINAL;

  let path = src;
  let srcObj = src;
  if (!useOriginal) {
    path = imageFile(src, size);
    srcObj = {
      src: path,
      webp: pathForMime(path, 'webp'),
      avif: pathForMime(path, 'avif')
    };
  }

  return (
    <CorePicture
      src={srcObj}
      alt={alt}
      height={$height}
      className={className}
      dataTestId={dataTestId}
    />
  );
};

export default Picture;
